import { KeyboardEvent, MouseEvent } from 'react';
import { toast } from 'react-toastify';
import { MdOutlineContentCopy } from 'react-icons/md';
import { copyToClipboard } from '@/utils/helpers';

interface CopyToClipboardProps {
  text: string;
  confirmationMessage?: string;
  iconSize?: number;
}

export const CopyToClipboard = ({ text, confirmationMessage, iconSize = 24 }: CopyToClipboardProps) => {
  const handleCopyToClipboard = (e?: MouseEvent) => {
    e?.stopPropagation();
    copyToClipboard(text);

    if (confirmationMessage) {
      toast.success(confirmationMessage);
    }
  };

  const onEditKeyDown = (e: KeyboardEvent<HTMLSpanElement>) => {
    e.stopPropagation();
    if (e.key === 'Enter') {
      handleCopyToClipboard();
    }
  };

  return (
    <span
      role="button"
      tabIndex={0}
      aria-label="Copy to clipboard"
      className="text-base-5 pointer-events-auto"
      onKeyDown={onEditKeyDown}
      onClick={handleCopyToClipboard}
    >
      <MdOutlineContentCopy size={iconSize} />
    </span>
  );
};
